module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-03@2x.e4e3602a.jpg";